:host {
  display: flex;
  align-items: center;
  transform: translateZ(0);
  z-index: 99;
}

::slotted(*) ion-button {
  --padding-top: 0;
  --padding-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}

::slotted(*) ion-button {
  --padding-top: 3px;
  --padding-bottom: 3px;
  --padding-start: 5px;
  --padding-end: 5px;
  -webkit-margin-start: 2px;
  margin-inline-start: 2px;
  -webkit-margin-end: 2px;
  margin-inline-end: 2px;
  min-height: 32px;
}

::slotted(*) .button-has-icon-only {
  --padding-top: 0;
  --padding-bottom: 0;
}

::slotted(*) ion-button:not(.button-round) {
  --border-radius: 4px;
}

:host-context(.ion-color)::slotted(*) .button {
  --color: initial;
  --border-color: initial;
  --background-focused: var(--ion-color-contrast);
}

:host-context(.ion-color)::slotted(*) .button-solid {
  --background: var(--ion-color-contrast);
  --background-focused: #000;
  --background-focused-opacity: .12;
  --background-activated: #000;
  --background-activated-opacity: .12;
  --background-hover: var(--ion-color-base);
  --background-hover-opacity: 0.45;
  --color: var(--ion-color-base);
  --color-focused: var(--ion-color-base);
}

:host-context(.ion-color)::slotted(*) .button-clear {
  --color-activated: var(--ion-color-contrast);
  --color-focused: var(--ion-color-contrast);
}

:host-context(.ion-color)::slotted(*) .button-outline {
  --color-activated: var(--ion-color-base);
  --color-focused: var(--ion-color-contrast);
  --background-activated: var(--ion-color-contrast);
}

::slotted(*) .button-clear,
::slotted(*) .button-outline {
  --background-activated: transparent;
  --background-focused: currentColor;
  --background-hover: transparent;
}

::slotted(*) .button-solid:not(.ion-color) {
  --background-focused: #000;
  --background-focused-opacity: .12;
  --background-activated: #000;
  --background-activated-opacity: .12;
}

::slotted(*) ion-icon[slot=start] {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  -webkit-margin-end: 0.3em;
  margin-inline-end: 0.3em;
  font-size: 24px;
  line-height: 0.67;
}

::slotted(*) ion-icon[slot=end] {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  -webkit-margin-start: 0.4em;
  margin-inline-start: 0.4em;
  font-size: 24px;
  line-height: 0.67;
}

::slotted(*) ion-icon[slot=icon-only] {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 28px;
  line-height: 0.67;
}